module.exports = __webpack_public_path__ + "img/error.c93789d0.svg";